import { NgModule } from '@angular/core';
import { DraggableDirective } from './draggable.directive';
import { DroppableDirective } from './droppable.directive';
import { DraggableHelper } from './draggable-helper.provider';
var DragAndDropModule = /** @class */ (function () {
    function DragAndDropModule() {
    }
    DragAndDropModule.forRoot = function () {
        return {
            ngModule: DragAndDropModule,
            providers: [DraggableHelper]
        };
    };
    DragAndDropModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DraggableDirective, DroppableDirective],
                    exports: [DraggableDirective, DroppableDirective]
                },] },
    ];
    /** @nocollapse */
    DragAndDropModule.ctorParameters = function () { return []; };
    return DragAndDropModule;
}());
export { DragAndDropModule };
//# sourceMappingURL=drag-and-drop.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-draggable-droppable/dist/esm/src/drag-and-drop.module.js
// module id = ./node_modules/angular-draggable-droppable/dist/esm/src/drag-and-drop.module.js
// module chunks = 3